import { FC } from "react";

interface Props {
  backgroundImageUrl?: string;
  titleColor?: string;
  title: string;
  subtitleColor?: string;
  subtitle?: string;
  showcase?: boolean;
  centered?: boolean;
  header?: boolean;
  shrinkOnMobile?: boolean;
  fitContent?: boolean;
}

export const Banner: FC<Props> = ({
  backgroundImageUrl = "https://i.imgur.com/QBdJNB4.jpeg",
  title,
  titleColor = "#FFFFFF",
  subtitle,
  subtitleColor = "#D5D5D5",
  showcase = false,
  centered = false,
  shrinkOnMobile = false,
  fitContent = false,
}) => {
  return (
    <div
      className={`banner ${showcase ? "banner--showcase" : ""} ${
        centered ? "banner--centered" : ""
      } ${shrinkOnMobile && showcase ? "banner--mobile-shrink-showcase" : ""} 
      ${fitContent ? "banner--fit-content" : ""}`}
      style={{
        backgroundImage: `url(${backgroundImageUrl})`,
      }}
    >
      <div className="banner__gradient">
        <div className="banner__content content-padding">
          <span
            className={"banner__content__title  " + (showcase ? "h1" : "h2")}
            style={{ color: titleColor }}
          >
            {title}
          </span>
          {subtitle && (
            <span
              className="banner__content__subtitle content"
              style={{ color: subtitleColor }}
            >
              {subtitle}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
